import { ILLGenericKeys, ILLActiveIngridient, ILLNameDescription, ILLPackageConfigurations, ILLInactiveIngridient} from './index';

export class ILLProductBase {
 productId: number;
 revision: number;
 proprietaryName: string;
 proprietaryNameSuffix: string;
 sourceNDCCode: string;
 estGenName: string;
 deaSchedule: ILLGenericKeys;
 dosageForm: ILLGenericKeys;
 routeOfAdmins: ILLGenericKeys[];
 activeIngredients: ILLActiveIngridient[];
 inActiveIngredients: ILLInactiveIngridient[];
 color: ILLNameDescription[];
 scoring: ILLGenericKeys;
 shape: ILLGenericKeys;
 shapeDesc: string;
 size: string;
 imprint: string;
 flavor: ILLNameDescription[];
 category: ILLGenericKeys;
 applicationNo: string;
 cosmeticCategory: string;
 cosmeticProduct: ILLGenericKeys;
 citation: ILLGenericKeys;
 status: ILLGenericKeys;
 startDate: Date;
 endDate: Date;
 ndcProductCode: string;
 packageConfigurations: ILLPackageConfigurations[];
 defaultStrengthDenominatorUnit: ILLGenericKeys;
 topLevelXMLNodeName: string;
 hasActiveIngredients: boolean;
 hasInactiveIngredients: boolean;
 description: string;
 quantityValue: string;
 quantityUnit: ILLGenericKeys;
 llModifiedOn: Date;
 productType: string;
 llFormName: string;
 llFormVersion: string;
 marketingCategory: string;
 marketingStartDate: Date;
 marketingEndDate: Date;
 listingRecordCertifiedThroughStatus: string;
 listingRecordCertifiedThroughDate: Date;
}


